import {
  Button,
  Card,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material"

const DistanceView = ({
  distance_query,
  set_distance_query,
  measure_mode,
  set_measure_mode,
}) => {
  const { from, to, distance } = distance_query
  if (!measure_mode) {
    return null
  }

  const km = distance / 1000

  return (
    <Card
      style={{
        position: "absolute",
        top: "70px",
        right: "10px",
        zIndex: 500,
        maxHeight: 500,
        overflow: "auto",
      }}
    >
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>Property</TableCell>
            <TableCell>Value</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell component="th" scope="row">
              From
            </TableCell>
            <TableCell component="th" scope="row">
              {from}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell component="th" scope="row">
              To
            </TableCell>
            <TableCell component="th" scope="row">
              {to}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell component="th" scope="row">
              Distance*
            </TableCell>
            <TableCell component="th" scope="row">
              {`${Math.round(km * 100) / 100} km`}
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
      <Typography variant="caption" style={{ margin: 10 }}>
        *Distances are measured along the road network.
      </Typography>

      <Button
        onClick={() => {
          set_distance_query({
            last_updated: null,
            from: null,
            to: null,
            distance: null,
          })
          set_measure_mode(false)
        }}
        fullWidth
      >
        Close
      </Button>
    </Card>
  )
}

export default DistanceView
